
import ListSchool from "./ListSchool.vue";
import { ref } from "vue";
export default {
  props: ["majorName", "title"],
  components: {
    ListSchool,
  },
  computed: {
    // getIntroduction() {
    //   return this.$store.state.ListSchool.introduction || "";
    // },
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      activeKey: ref("1"),
      componentKey: 0,
    };
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    handleBack() {
      this.$emit('handleBack')
    }
  },
};
